// extracted by mini-css-extract-plugin
export default {"parent-mode":"child-tab-bar_parent-mode__8jO55","bar":"child-tab-bar_bar__SBJo6","active":"child-tab-bar_active__ZeYci"};